import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, MessageSquare, Layout, CheckSquare } from 'lucide-react';
export function WhatYouGetSection() {
  const phases = [{
    title: 'Posicionamiento',
    desc: 'Cómo iniciar sin pedir validación.',
    icon: <BookOpen className="w-6 h-6" data-id="element-196" />
  }, {
    title: 'Tensión',
    desc: 'Cómo evitar conversaciones aburridas.',
    icon: <MessageSquare className="w-6 h-6" data-id="element-197" />
  }, {
    title: 'Ritmo',
    desc: 'Cuándo avanzar y cómo cerrar.',
    icon: <Layout className="w-6 h-6" data-id="element-198" />
  }, {
    title: 'Control',
    desc: 'Cómo sostener deseo sin volverte dependiente.',
    icon: <CheckSquare className="w-6 h-6" data-id="element-199" />
  }];
  const responses = ['jajaja', 'no sé', 'estoy ocupada', 'te veo como amigo', 'no busco nada serio', 'Ghosting', 'Conversaciones frías'];
  return <section className="py-24 px-4 bg-brand-black" data-id="element-200">
      <div className="container mx-auto max-w-6xl" data-id="element-201">
        <div className="grid lg:grid-cols-2 gap-16" data-id="element-202">
          {/* Left: Manual Structure */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-203">
            <h3 className="text-3xl font-heading font-bold text-white mb-8 border-l-4 border-brand-red pl-4" data-id="element-204">
              📘 Manual Principal (PDF Premium)
            </h3>
            <div className="space-y-6" data-id="element-205">
              {phases.map((phase, i) => <div key={i} className="flex gap-4 p-4 bg-brand-dark rounded border border-white/5 hover:border-brand-red/20 transition-colors" data-id="element-206">
                  <div className="text-brand-red mt-1" data-id="element-207">{phase.icon}</div>
                  <div data-id="element-208">
                    <h4 className="text-xl font-bold text-white mb-1" data-id="element-209">
                      {phase.title}
                    </h4>
                    <p className="text-gray-400" data-id="element-210">{phase.desc}</p>
                  </div>
                </div>)}
            </div>
          </motion.div>

          {/* Right: Response Library */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-211">
            <h3 className="text-3xl font-heading font-bold text-white mb-8 border-l-4 border-brand-gold pl-4" data-id="element-212">
              📚 Biblioteca de Respuestas
            </h3>
            <div className="bg-brand-dark p-8 rounded border border-white/5" data-id="element-213">
              <p className="text-gray-300 mb-6" data-id="element-214">
                Respuestas listas para copiar y pegar cuando ella dice:
              </p>
              <div className="flex flex-wrap gap-3" data-id="element-215">
                {responses.map((res, i) => <span key={i} className="bg-black/50 text-gray-200 px-4 py-2 rounded-full border border-white/10 text-sm" data-id="element-216">
                    "{res}"
                  </span>)}
              </div>

              <div className="mt-8 pt-8 border-t border-white/10 space-y-4" data-id="element-217">
                <div className="flex items-center text-white" data-id="element-218">
                  <CheckSquare className="w-5 h-5 text-brand-gold mr-3" data-id="element-219" />
                  <span data-id="element-220">🧰 Plantillas Editables</span>
                </div>
                <div className="flex items-center text-white" data-id="element-221">
                  <CheckSquare className="w-5 h-5 text-brand-gold mr-3" data-id="element-222" />
                  <span data-id="element-223">🧠 Checklist Antes de Enviar</span>
                </div>
                <div className="flex items-center text-white" data-id="element-224">
                  <CheckSquare className="w-5 h-5 text-brand-gold mr-3" data-id="element-225" />
                  <span data-id="element-226">📌 Errores invisibles que matan la atracción</span>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}